import React, { useState, useEffect } from 'react'
import { useRouter } from 'next/router'

import { Sorting } from '../../SearchNearParking.styled'

import SortDropdownUI from './SortDropdownUI'
import { SortOptions, SortType } from './Sorting.types'

interface SortDropdownProps {
  initialValue?: string | undefined
}

const SortDropdown: React.FC<SortDropdownProps> = ({ initialValue }) => {
  const [selectedSort, setSelectedSort] = useState<any>(
    initialValue ?? SortOptions[0]
  )
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const router = useRouter()

  const handleDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen)
  }

  const handleOptionSelect = (sort: SortType) => {
    setSelectedSort(sort)
    setIsDropdownOpen(false)

    const newQuery = { ...router.query, sorting: sort.key }
    router.push({ pathname: router.pathname, query: newQuery }, undefined, {
      shallow: true
    })
  }

  useEffect(() => {
    initialValue && setSelectedSort(initialValue)
  }, [initialValue])

  return (
    <Sorting>
      <SortDropdownUI
        selectedSort={selectedSort}
        isDropdownOpen={isDropdownOpen}
        sortOptions={SortOptions}
        handleDropdownToggle={handleDropdownToggle}
        handleOptionSelect={handleOptionSelect}
      />
    </Sorting>
  )
}

export default SortDropdown
